import { useEffect, useState } from 'react';

const STEPS = [
  { icon: '🔍', text: 'Analizando documento...' },
  { icon: '👤', text: 'Extrayendo datos...' },
  { icon: '🔐', text: 'Comparando rostros...' },
  { icon: '✅', text: 'Verificando información...' },
];

export function ProcessingStep() {
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentStep((prev) => (prev + 1) % STEPS.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center p-4 min-h-[60vh]">
      <div className="text-center space-y-6 md:space-y-8 max-w-md md:max-w-lg mx-auto">
        {/* Spinner animado - infinito */}
        <div className="relative w-28 h-28 md:w-40 md:h-40 mx-auto">
          {/* Círculo de fondo */}
          <div className="absolute inset-0 border-4 md:border-6 border-sky-100 rounded-full" />

          {/* Spinner giratorio infinito */}
          <svg className="absolute inset-0 w-full h-full animate-spin" style={{ animationDuration: '1.5s' }} viewBox="0 0 112 112">
            <circle
              cx="56"
              cy="56"
              r="52"
              stroke="url(#gradient)"
              strokeWidth="7"
              fill="none"
              strokeLinecap="round"
              strokeDasharray="180 164"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#38bdf8" />
                <stop offset="100%" stopColor="#0ea5e9" />
              </linearGradient>
            </defs>
          </svg>

          {/* Icono central */}
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-3xl md:text-5xl animate-pulse">
              {STEPS[currentStep].icon}
            </span>
          </div>
        </div>

        {/* Texto de estado */}
        <div>
          <h2 className="text-xl md:text-3xl font-bold text-gray-900">
            Verificando tu identidad
          </h2>
          <p className="text-gray-600 mt-1.5 md:mt-2 text-sm md:text-base">
            {STEPS[currentStep].text}
          </p>
        </div>

        {/* Pasos de verificación */}
        <div className="space-y-2 md:space-y-3 text-left">
          {STEPS.map((step, index) => (
            <div
              key={index}
              className={`flex items-center gap-2.5 md:gap-3 transition-opacity duration-300 ${
                index <= currentStep ? 'opacity-100' : 'opacity-40'
              }`}
            >
              <span className={`text-base md:text-xl ${index < currentStep ? 'text-sky-500' : ''}`}>
                {index < currentStep ? '✅' : step.icon}
              </span>
              <span className="text-sm md:text-base text-gray-600">{step.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


